import React from 'react'
import { LongHumanReadableTime } from 'src/date'
import { PatientResponse } from 'src/graphql.generated'
import LinkedItemPreview from './LinkedItemPreview'

type Props = {
  response: Pick<PatientResponse, 'title' | 'category' | 'createdAt'>
  onRemoveResponse?: () => void
}

const ResponsePreview: React.FunctionComponent<Props> = ({ response, onRemoveResponse }) => {
  const { title, category, createdAt } = response

  return (
    <LinkedItemPreview
      title={title ?? undefined}
      iconCategory={category}
      summary={<LongHumanReadableTime value={createdAt} />}
      onRemove={onRemoveResponse}
      removeAriaLabel="remove-response"
    />
  )
}

export default ResponsePreview
